module.exports = __webpack_public_path__ + "img/lrobotbox.ab82401c.png";